import React from 'react';
import { withStyles, Theme } from '@material-ui/core';

const Parameter = ({
  classes = {},
  label,
  value,
  unit,
}: {
  classes?: Partial<Record<'root' | 'label' | 'value' | 'unit', string>>;
  label: React.ReactNode;
  unit?: React.ReactNode;
  value: React.ReactNode;
}): JSX.Element => {
  return (
    <div className={classes.root}>
      <div className={classes.label}>{label}</div>
      <div className={classes.value}>
        {value}
        {unit && <span className={classes.unit}>{unit}</span>}
      </div>
    </div>
  );
};

const ParameterStyled = withStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(1, 2),
    '&:nth-child(odd)': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  label: {
    width: '40%',
    minWidth: theme.spacing(20),
  },
  value: {
    flexGrow: 1,

    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary.dark,
  },
  unit: {
    marginLeft: '0.5ch',
    // fontWeight: theme.typography.fontWeightRegular,
  },
}))(Parameter) as typeof Parameter;

export default ParameterStyled;
